import * as React from 'react';
import { RotatingBannerContainer, RotatingText } from './RotatingBanner.style';
import Marquee from 'react-fast-marquee';

const RotatingBanner = ({ rotatingText, bannerRepeat }) => {
  const textArray = Array(bannerRepeat).fill(0);
  return (
    <RotatingBannerContainer>
      <Marquee gradient={false} speed={30}>
        {textArray.map(text => (
          <RotatingText>{rotatingText}</RotatingText>
        ))}
      </Marquee>
    </RotatingBannerContainer>
  );
};

export default RotatingBanner;
